import { VerifiedButton, NotVerifiedButton, NotVerifiedWrapper } from 'components/views/verification/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import WarningIcon from '@mui/icons-material/Warning';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';

interface Props {
  isVerified: boolean;
  onClick: () => void;
  variant?: 'text' | 'outlined';
  formikName?: string;
}

export const VerifiedOrUnverifiedButton = ({ isVerified, onClick, variant = 'text', formikName }: Props) => {
  if (isVerified) {
    return (
      <VerifiedButton variant={variant} size="small" fullWidth onClick={onClick} startIcon={<CheckCircleIcon />}>
        Verified (Change)
      </VerifiedButton>
    );
  }

  return (
    <NotVerifiedWrapper>
      <NotVerifiedButton variant={variant} size="small" fullWidth onClick={onClick} startIcon={<WarningIcon />} >
        Not Verified (Click Here)
      </NotVerifiedButton>
      {formikName ? <AlluraFormikErrorMessage fieldName={formikName} /> : null}
    </NotVerifiedWrapper>
  );
};
